import * as types from './mutation-types'

export const ActionSetSnackbar = ({
  commit
}, payload) => {
  payload.showing = true;
  payload.color = payload.color || 'success';
  commit(types.SET_SNACKBAR, payload);
}

export const ActionRemoveSnackbar = ({
  commit
}, payload) => {
  commit(types.REMOVE_SNACKBAR, payload);
}